import React from 'react'
import ReactDOM from 'react-dom'

import { Provider } from 'react-redux'
import configureStore from './store/store'
import registerServiceWorker from './registerServiceWorker';
import App from './App/index.js'
import './assets/styles/index.css'

// Container component
ReactDOM.render(
  <Provider store={configureStore()}>
    <App/>
  </Provider>,
  document.getElementById('root')
)
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js